import { createI18n } from 'vue-i18n'
import en from './Locales/en.json'
import sv from './Locales/sv.json'

function loadLocaleMessages() {
    const locales = [{ en: en }, { sv: sv }]
    const messages = {}
    locales.forEach(lang => {
        const key = Object.keys(lang)
        messages[key] = lang[key]
    })
    return messages
}

function getBrowserLocale() {
    const locale = navigator.language || navigator.languages?.[0] || 'en'

    return locale.toLowerCase().startsWith('sv') ? 'sv' : 'en'
}

export default createI18n({
    globalInjection: true,
    legacy: false,
    locale: getBrowserLocale(),
    fallbackLocale: ['en', 'sv'],
    messages: loadLocaleMessages(),
})
